<template>
  <div class="sc-stories">
    <div class="container">
      <h2 class="sc-title -center -margin-bottom">Príbehy kolegov</h2>
      <div class="row">
        <div class="column -md4">
          <div
            v-for="(story, i) in stories"
            :key="i"
            class="sc-story-button"
            :class="{ '-active': activeIndex === i }"
            @click="activeIndex = i"
          >
            <img :src="story.image" :alt="story.name" class="sc-story-button-image">
            <div class="sc-story-button-text">
              <div class="sc-story-button-name">{{ story.name }}</div>
              <div class="sc-story-button-position">{{ story.position }}</div>
            </div>
          </div>
        </div>
        <div class="column -md8 sc-story-article">
          <div
            class="sc-story-article-name"
            v-text="activeStory.name"
          />
          <div
            class="sc-story-article-position"
            v-text="activeStory.position"
          />
          <h3
            class="sc-story-article-quote"
            v-text="activeStory.quote"
          />
          <div
            class="sc-story-article-body"
            v-html="activeStory.body"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-irregular-whitespace */
export default {
  data() {
    return {
      stories: [
        {
          name: 'Jaroslav Sýkora',
          position: 'riaditeľ obchodu',
          image: require('@/assets/photos/jaro-sykora.jpg'),
          quote: '„Potrebnú podporu pre obchod som oceňoval na začiatku a dnes ju pomáham formovať pre všetkých, ktorí majú chuť sa na štartovaciu čiaru postaviť.“',
          body: `
            <p>Pred dvadsiatimi rokmi som odštartoval trasu Wüstenrot a odvtedy som nemal potrebu presadnúť do iného tímu. Od začiatku som oceňoval servisný tím a zázemie, ktoré svojim pilotom W1 garantuje. A ako sa rozvíjala spoločnosť, rástol som aj ja.</p>
            <p>Na štartovaciu  dráhu som nastúpil ako začínajúci finančný poradca, už po roku som sa preradil na dráhu servisného pracovníka, za tri roky ako vedúci servisného centra a za päť rokov som bral zatáčky ako krajský riaditeľ pre Košický a Prešovský kraj. </p>
            <p>Napriek rýchlemu tempu si nepamätám, že by som mal na trase vážne prekážky a už vôbec som sa nemohol sťažovať na Wüstenrot servis. Nakoniec, bez kvalitnej podpory zo zázemia sa na dlhé trasy ísť neoplatí.</p>
            <p>Potrebnú podporu pre obchod som oceňoval na začiatku a dnes ju pomáham formovať pre všetkých, ktorí majú chuť sa na štartovaciu čiaru postaviť. Pretože viem aká je dôležitá. Ako riaditeľ pre vlastný a externý odbyt sa podpisujem na vytváraní obchodnej siete, odmeňovaniu a motivácie.  A stále si pamätám, ako mi na začiatku trasy pomohol dobre servisný tím sa nakopnúť. Skúsenosti z mojich osobných prvých kilometrov premietam do podpory nových jazdcov W1.</p>
          `,
        },
        {
          name: 'Lucia Györgyová',
          position: 'manažérka obchodnej siete',
          image: require('@/assets/photos/lucia-gyo.jpg'),
          quote: '„W-práca ma napĺňa a splnila moje očakávania aj po finančnej stránke.“',
          body: `
            <p>Na Wüstenrot-štartovaciu čiaru som sa ako obchodník postavila v roku 2012. Najlepšie rozhodnutie, aké som vo svojom pracovnom živote mohla spraviť. </p>
            <p>Portfólio produktov a filozofia rodinnej spoločnosti mi hneď prirástla k srdcu. Vážim si podporu podnikania, motivačné súťaže a neustále bezplatné vzdelávanie. Jednoducho práca ma napĺňa a splnila moje očakávania aj po finančnej stránke.</p>
            <p>Hneď po prvých kolách som sa kvalifikovala do manažérskej ligy. A práve pozícia manažéra obchodnej skupiny mi počas trojročnej materskej dovolenky zabezpečila nadštandardný príjem. No čo je dôležité, mohla som sa aj naplno venovať dcére. Nemusela som ani zaradiť nižšiu rýchlosť. S klientami som bola aj počas materskej dovolenky neustále v kontakte. Pretože som naplno využívala možnosť, ktorú Wüstenrot ponúka - pracovať online.</p>
            <p>W-práca mi dáva možnosť byť vo svete financií maximálne informovaná. Vďaka množstvu  ľudí, s ktorými sa stretávam, som získala veľké množstvo dobrých známych. A to ani nehovorím o skvelom kolektíve, s ktorým pracujem v našej agentúre.</p>

          `,
        },
        {
          name: 'Valika a Mirko Germanovci',
          position: 'agentúrne riaditeľstvo',
          image: require('@/assets/photos/germanovci.jpg'),
          quote: '„Radi spolupracujeme s kolegami, ktorí do zamestnania nemusia, ale chcú chodiť, ktorí nerobia biznis, ale majú záujem ľuďom pomôcť informáciami a službou.“',
          body: `
            <p>Štartovací výstrel u nás zaznel pred takmer dvadsiatimi rokmi. Ešte sa platilo slovenskými korunami. Od roku 2001 sa toho zmenilo veľa, no jedna vec ostala rovnaká – ľudia naďalej chcú byť zabezpečení a svoje peniaze mať zhodnotené. A ani pandémia na tom nič nezmenila. Pretože niektoré slovné spojenia znamenajú stále to isté bez ohľadu na to, koľko zákrut Slovensko za 20 rokov absolvovalo.</p>
            <p>Napríklad slovíčka „dobre zabezpečený“ stále v našom slovníku znamená mať dostatok financií  v čase, keď to najviac potrebujeme, v situácii, ktorá nastala bez nášho pričinenia. „ Permanentná starostlivosť  o svoje financie“ v našej agentúre prináša neustále posudzovanie spôsobu nakladania s peniazmi tým spôsobom, aby nestrácali na hodnote, skôr prinášali zisk a tým aj spokojnosť.</p>
            <p>Nie je nás v agentúre veľa, ale všetci účastníci tohto procesu sú dobrí, odborne zdatní  ľudia. Všetci sa môžu kedykoľvek, ktorémukoľvek klientovi priamo pozrieť do očí počas  alebo po ukončení spolupráce.</p>
            <p>Radi spolupracujeme s kolegami, ktorí do zamestnania nemusia, ale chcú chodiť, ktorí nerobia biznis, ale majú záujem ľuďom pomôcť informáciami a službou.  Ak po čase nastane situácia, ktorú sme v počiatkoch vzájomného vzťahu s klientom popisovali  a vstúpi do hry naša poisťovňa alebo banka, radi sa oprieme do kresla a uvedomíme si, že to za to stálo.</p>
          `,
        },
      ],
      activeIndex: 0,
    };
  },
  computed: {
    activeStory() {
      return this.stories[this.activeIndex];
    },
  },
};
</script>

<style lang="scss" scoped>
.sc-stories {
  padding: 0 0 120px;
  margin-top: 120px;
  background-image: url('../assets/sc/pattern-stories.svg');
  background-position: left 350px;
  background-repeat: no-repeat;
  background-size: 75% auto;
  @media screen and (min-width: $screen-md) {
    background-size: initial;
  }
  .sc-story-button {
    padding: 15px 30px;
    display: flex;
    align-items: center;
    color: $gray-400;
    margin-bottom: 5px;
    cursor: pointer;
    transition: all .3s;
    .sc-story-button-image {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .sc-story-button-text {
      margin-left: 40px;
    }
    .sc-story-button-name {
      font-size: 18px;
      font-weight: 700;
    }
    .sc-story-button-position {
      font-size: 14px;
    }
    &:hover {
      background-color: $gray-200;
    }
    &.-active {
      background-color: $gray-200;
      color: $primary;
    }
  }
  .sc-story-article {
    padding-top: 20px;
    .sc-story-article-name,
    .sc-story-article-position,
    .sc-story-article-quote {
      max-width: 500px;
    }
    .sc-story-article-name {
      color: $primary;
      font-size: 28px;
      font-weight: 700;
    }
    .sc-story-article-position {
      margin-bottom: 30px;
    }
    .sc-story-article-quote {
      font-weight: 700;
      font-size: 20px;
      margin-bottom: 30px;
      line-height: 1.3;
      @media screen and (min-width: $screen-md) {
        font-size: 24px;
      }
    }
  }
}
</style>

<style lang="scss">
.sc-story-article-body {
  max-width: 620px;
  padding-right: 40px;
  font-size: 14px;
  img {
    display: block;
    width: 100%;
    height: auto;
    margin: 40px 0 40px 40px;
  }
  @media screen and (min-width: $screen-md) {
    font-size: 18px;
  }
}
</style>
